"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOtpChannelRepository = void 0;
const resolver_1 = require("./resolver");
const mapper_1 = require("./mapper");
exports.getOtpChannelRepository = {
    get: async (api, progressId) => {
        const response = await (0, resolver_1.fetchGetOtpChannel)(api, progressId);
        return (0, mapper_1.mapOtpChannel)(response.data);
    },
};
//# sourceMappingURL=repository.js.map